

















































































    import { Component, Vue} from "vue-property-decorator";
    import TextHeaderSmall from "@/components/Common/TextHeaderSmall.vue";
    import TextHeader from "@/components/Common/TextHeader.vue";

    @Component({
        components: {
            TextHeaderSmall,
			TextHeader,
        }
    })
    export default class VacancyPage extends Vue{
        mounted(){
            let container = this.$el.querySelector(this.$route.hash);
            if(container){
                container.scrollIntoView();
			}
		}
    }
